import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as _props from "../../../../_redux/_services/JobPostingSlice";
import JobpostingDetailsPortals from "./JobpostingDetailsPortals";

import { GetUserInfo } from "../../../../_utilities/getUserInfo";
import JobpostingDetailsPortalsEdit from "./JobpostingDetailsPortalsEdit";
import { ApplicantEditIcon } from "../../../../Icons/ApplicantEditIcon";
const initalState = { data: null, message: "", isloader: true };

const JobpostingDetailsPortalsView = ({ selectedJobId }) => {
  const [listOfPF, setListOfPF] = useState(
    JSON.parse(JSON.stringify(listOfPlatform)),
  );
  const [flatFee, setFlatFee] = useState("");
  const [flatFeeCountryId, setFlatFeeCountryId] = useState("");
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [defaultflatFee, setDefaultFlatFee] = useState("");
  const [defaultflatFeeCountryId, setDefaultFlatFeeCountryId] = useState("");
  const [jobId, setJobId] = useState(null);
  const [isValidUser, setIsValidUser] = useState(false);
  const [showEditComponent, setShowEditComponent] = useState(false);

  const getDetails = useSelector((state) => state.Jobpostingsbyid.data);
  const getDetailsCode = useSelector((state) => state.Jobpostingsbyid.code);
  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  useEffect(() => {
    if (getDetailsCode === 404) {
      setIsValidUser(true);
    }
  }, [getDetailsCode]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const updateHandler = (val, type) => {
    if (type === "flatFee") {
      setFlatFee(val);
    } else if (type === "portalData") {
      setIsValidUser(val);
    }
  };

  useEffect(() => {
    async function init() {
      let userDetails = await GetUserInfo();
      let val =
        userDetails[0].flatFee !== null && userDetails[0].flatFee !== 0
          ? userDetails[0].flatFee
          : "";
      let CountryVal =
        userDetails[0].flatFeeCountryId !== null &&
        userDetails[0].flatFeeCountryId !== 0
          ? userDetails[0].flatFeeCountryId
          : "";
      setDefaultFlatFee(val);
      setDefaultFlatFeeCountryId(CountryVal);
    }
    init();
  }, []);

  const onChangePlatformHandler = (e, item) => {
    let data = JSON.parse(JSON.stringify(listOfPF));
    let Index = data.findIndex((x) => x.id === item.id);
    if (Index !== -1) {
      data[Index].checked = e.target.checked;
      data[Index].value = e.target.checked ? 1 : 0;
      setListOfPF(data);
    }
  };

  // getData
  useEffect(() => {
    if (selectedJobId) {
      dispatch(_props.jobpostingsbyidAsync(selectedJobId));
    }
  }, [selectedJobId]);

  useEffect(() => {
    if (getDetails !== null && getDetails !== undefined) {
      let postingData = JSON.parse(JSON.stringify(getDetails));
      let portals = JSON.parse(JSON.stringify(listOfPF));
      portals[0].value = postingData.CSPortal;
      portals[0].checked = parseInt(postingData.CSPortal) === 1 ? true : false;
      portals[1].value = postingData.VSPortal;
      portals[1].checked = parseInt(postingData.VSPortal) === 1 ? true : false;
      portals[2].value = postingData.EPortal;
      portals[2].checked = parseInt(postingData.EPortal) === 1 ? true : false;
      portals[3].value = postingData.JBPortal;
      portals[3].checked = parseInt(postingData.JBPortal) === 1 ? true : false;
      setJobId(postingData.id);
      setFlatFee(
        postingData?.flatFee && parseInt(postingData.CSPortal) === 1
          ? postingData.flatFee
          : defaultflatFee,
      );
      setFlatFeeCountryId(
        postingData?.flatFeeCountryId && parseInt(postingData.CSPortal) === 1
          ? postingData.flatFeeCountryId
          : defaultflatFeeCountryId,
      );
      try {
        postingData.vendorIds = JSON.parse(postingData.vendorIds);
      } catch (e) {
        postingData.vendorIds = postingData.vendorIds
          ? postingData.vendorIds.split(',').map(Number)
          : [];
      }
      setListOfPF(portals);
      setSelectedVendors(postingData.vendorIds);
      // dispatch(_props.jobpostingsbyidStartReducer(initalState));
    }
  }, [getDetails]);

  const onGetValidData = (data) => {
    console.log(data);
  };

  return (
    <>
      {showEditComponent === false ? (
        <>
          {!isValidUser && (
            <div className="actionBtnRtl1" style={{ marginTop: "-12px" }}>
              <IconButton
                sx={{
                  textTransform: "capitalize",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
                onClick={() => {
                  setShowEditComponent(true);
                }}
              >
                <ApplicantEditIcon width={"34"} height={"34"} />
                <span
                  style={{
                    marginLeft: "10px",
                    fontSize: "16px",
                    color: "#000000",
                    fontWeight: "500",
                  }}
                >
                  Edit
                </span>
              </IconButton>
            </div>
          )}
          <JobpostingDetailsPortals
            componentType="View"
            onReceiveHandler={onChangePlatformHandler}
            data={listOfPF}
            flatFee={flatFee}
            flatFeeCountryId={flatFeeCountryId}
            vendors={selectedVendors}
            updateHandler={updateHandler}
          />
        </>
      ) : (
        <JobpostingDetailsPortalsEdit
          onReceiveHandler={() => {
            dispatch(_props.jobpostingsbyidAsync(selectedJobId));
            setShowEditComponent(false);
          }}
          selectedJobId={selectedJobId}
        />
      )}
    </>
  );
};

export default JobpostingDetailsPortalsView;

const listOfPlatform = [
  {
    id: 3,
    name: "CSPortal",
    title: "Cloud Sourcing Platform",
    checked: false,
    value: 0,
  },
  {
    id: 2,
    name: "VSPortal",
    title: "Vendor Sourcing Platform",
    checked: false,
    value: 0,
  },
  {
    id: 4,
    name: "EPortal",
    title: "Employee Platform",
    checked: false,
    value: 0,
  },
  {
    id: 5,
    name: "JBPortal",
    title: "Job Board Platform",
    checked: false,
    value: 0,
  },
];
